import { render, staticRenderFns } from "./StatusReserve.vue?vue&type=template&id=fd25892c&scoped=true&"
import script from "./StatusReserve.vue?vue&type=script&lang=js&"
export * from "./StatusReserve.vue?vue&type=script&lang=js&"
import style0 from "./StatusReserve.vue?vue&type=style&index=0&id=fd25892c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd25892c",
  null
  
)

export default component.exports